import React from 'react';
import {IoglMappingChange} from '../../../backend/model';
import {operators, TableDetails, TableInput, useTableCreation} from '../../TableTemplate';
import { IogLink, RuleLongLink } from '../../TableItemLink';

const TABLE_ID = 'dynamicExecutionPage-ioglsTable';

const COLUMN_DEFINITIONS = [
    {
        id: 'iogId',
        header: 'Inventory Owner Group Id',
        cell: (ioglMappingChange: IoglMappingChange): JSX.Element => <IogLink iogId={ioglMappingChange.iogId}/>,
        sortingField: 'iogId',
    },
    {
        id: 'fcId',
        header: 'Fulfillment Center Id',
        cell: (ioglMappingChange: IoglMappingChange) => ioglMappingChange.fcId,
    },
    {
        id: 'ifoId',
        header: 'Inventory Fiscal Owner Id',
        cell: (ioglMappingChange: IoglMappingChange) => ioglMappingChange.ifoId ?? '',
    },
    {
        id: 'inboundEnabled',
        header: 'Inbound Enabled',
        cell: (ioglMappingChange: IoglMappingChange) => ioglMappingChange.inboundEnabled ?? '',
    },
    {
        id: 'fulfillmentEnabled',
        header: 'Fulfillment Enabled',
        cell: (ioglMappingChange: IoglMappingChange) => ioglMappingChange.fulfillmentEnabled,
    },
    {
        id: 'operation',
        header: 'Operation',
        cell: (ioglMappingChange: IoglMappingChange) => ioglMappingChange.dynamicExecutionOperation,
    },
    {
        id: 'mappingStatus',
        header: 'Mapping Status',
        cell: (ioglMappingChange: IoglMappingChange) => ioglMappingChange.mappingStatus,
    },
    {
        id: 'ruleName',
        header: 'Rule',
        cell: (ioglMappingChange: IoglMappingChange) => <RuleLongLink ruleGroupRuleName={ioglMappingChange.ruleName}/>,
    },
];

const FILTERING_PROPERTIES = [
    {
        propertyLabel: 'IOG',
        key: 'iogId',
        groupValuesLabel: 'IOG ID values',
        operators: operators,
    },
    {
        propertyLabel: 'FC',
        key: 'fcId',
        groupValuesLabel: 'FC ID values',
        operators: operators,
    },
    {
        propertyLabel: 'IFO',
        key: 'ifoId',
        groupValuesLabel: 'IFO ID values',
        operators: operators,
    },
    {
        propertyLabel: 'Inbound Enabled',
        key: 'inboundEnabled',
        groupValuesLabel: 'Inbound Enabled values',
        operators: operators,
    },
    {
        propertyLabel: 'Fulfillment Enabled',
        key: 'fulfillmentEnabled',
        groupValuesLabel: 'Fulfillment Enabled values',
        operators: operators,
    },
    {
        propertyLabel: 'Operation',
        key: 'operation',
        groupValuesLabel: 'Operation values',
        operators: operators,
    },
    {
        propertyLabel: 'Mapping Status',
        key: 'mappingStatus',
        groupValuesLabel: 'Mapping Status values',
        operators: operators,
    },
    {
        propertyLabel: 'Rule',
        key: 'ruleName',
        groupValuesLabel: 'Rule name',
        operators: operators,
    },
];

const IoglTable: React.FC<TableInput> = ({tableItems, fileName}) => {
    const tableDetails: TableDetails = {
        tableId: TABLE_ID,
        header: `Changed ${tableItems.length} IOGLs`,
        fileName: fileName,
        getRow: function (row: IoglMappingChange): string[] {
            return [
                row.iogId,
                row.fcId,
                row.ifoId,
                String(row.inboundEnabled ?? ""),
                String(row.fulfillmentEnabled ?? ""),
                row.dynamicExecutionOperation,
                row.mappingStatus
            ];
        },
    };
    return useTableCreation(tableDetails, COLUMN_DEFINITIONS, tableItems, FILTERING_PROPERTIES);
};

export default IoglTable;
